
import React, { useState } from "react";
import { IoMdCloseCircle } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import style from "./PanelAdministrador.module.css";
import Header from "../header/Header";
import Switcher1 from '../switch/switch1'
import { crearProducto } from "../../repositorios/apiServer";


export default function PanelAdministrador() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nombrePlato: "",
    descripcion: "",
    alergenos: "",
    categoria: "",
    tipoPlato: "",
    precio: "",
    precioUnidad: false,
    publicado: false,
    precioPeso: false,
  });




  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Formulario enviado", formData);

    try {
        const res = await crearProducto({
            nombre: formData.nombrePlato, 
            descripcion: formData.descripcion,
            categoria: formData.categoria,
            tipo_plato: formData.tipoPlato, 
            precio: parseFloat(formData.precio), 
            precio_unidad: formData.precioUnidad, 
            precio_peso: formData.precioPeso, 
            publicado: formData.publicado
        });

        if (res.insertedId) {
            console.log("Producto registrado con ID:", res.insertedId);
        }
    } catch (error) {
        console.error("Error al registrar producto:", error);
    }
};


  const icono_cerrar = () => {
    navigate("/carta");
  };

  return (
    <section className={style.principal_panel}>
      <section className="div_encabezado">
        <Header />
      </section>
      <div className={style.div_texto}>
        <span className={style.textos}>Añade o edita un elemento</span>
      </div>
      <form onSubmit={handleSubmit}>
        <div className={style.div_plato}>
          <span className={style.texto}>Nombre del plato</span>
          <input
            type="text"
            name="nombrePlato"
            placeholder="Escribe aquí el nombre del plato"
            className={style.formato}
            value={formData.nombrePlato}
            onChange={handleChange}
          />
          <span className={style.texto}>Descripción</span>
          <textarea
            name="descripcion"
            placeholder="Escribe aquí una breve descripción"
            className={style.formato}
            value={formData.descripcion}
            onChange={handleChange}
          ></textarea>
        </div>
        <div className={style.div_divs}>
          <div className={style.div_inputs}>
            <div className={style.contenedor}>
              <span className={style.textos}>Alérgenos</span>
              <select name="alergenos" className={style.formato_select} value={formData.alergenos} onChange={handleChange}>
                <option value="">Seleccionar</option>
                <option value="Gluten">Gluten</option>
                <option value="Huevo">Huevo</option>
                <option value="Soja">Soja</option>
                <option value="Frutos secos">Frutos secos</option>
              </select>
            </div>
            <div className={style.contenedor}>
              <span className={style.textos}>Categoría</span>
              <select name="categoria" className={style.formato_select} value={formData.categoria} onChange={handleChange}>
                <option value="">Seleccionar</option>
                <option value="Sugerencias">Sugerencias</option>
                <option value="Ensaladas">Ensaladas</option>
                <option value="Principales">Principales</option>
                <option value="Postres">Postres</option>
              </select>
            </div>
          </div>
          <div className={style.div_inputs}>
            <div className={style.contenedor}>
              <span className={style.textos}>Tipo de plato</span>
              <select name="tipoPlato" className={style.formato_select} value={formData.tipoPlato} onChange={handleChange}>
                <option value="">Seleccionar</option>
                <option value="Pescados a la brasa">Pescados a la brasa</option>
                <option value="Arroces">Arroces</option>
               
                <option value="Postres">Postres</option>
              </select>
            </div>
            <div className={style.contenedor}>
              <span className={style.textos}>Precio</span>
              <input
                type="text"
                name="precio"
                placeholder="Escribe aquí el precio final"
                className={style.formato_select}
                value={formData.precio}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
        <div className={style.div_principal_checkbox}>
         
          <div className={style.div_switches}>
            <div className={style.div_formato}>
          <span className={style.textos}>
            Precio unidad
           </span>
           <Switcher1
            checked={formData.precioUnidad}
            onChange={(e) => setFormData({ ...formData, precioUnidad: e.target.checked })}
            />


            </div>
            <div className={style.div_formato}>
          <span className={style.textos}>
            Publicado
           </span>
           <Switcher1
            checked={formData.precioUnidad}
            onChange={(e) => setFormData({ ...formData, publicado: e.target.checked })}
            />

            </div>
            <div className={style.div_formato}>
          <span className={style.textos}>
            Precio peso
           </span>
           <Switcher1
            checked={formData.precioUnidad}
            onChange={(e) => setFormData({ ...formData, precioPeso: e.target.checked })}
            />

            </div>


          </div>
         
        </div>
        <div className={style.div_boton}>
          <button type="submit" className={style.formato_boton}>Guardar cambios</button>
        </div>
      </form>
      <div className={style.div_imagen}>
        <IoMdCloseCircle className={style.icono} onClick={icono_cerrar} />
      </div>
      <div className={style.div_texto_cerrar}>
        <span className={style.texto_cerrar}>Salir sin guardar</span>
      </div>
    </section>
  );
}
